import React from "react";
import { useTranslation } from "@/i18n/I18nProvider";

export default function Terms() {
  const { t } = useTranslation();
  const blocks = [
    ["editor_title", "editor_body"],
    ["hosting_title", "hosting_body"],
    ["ip_title", "ip_body"],
    ["liability_title", "liability_body"],
    ["law_title", "law_body"],
    ["mediation_title", "mediation_body"],
    ["contact_title", "contact_body"],
  ];
  return (
    <div className="bg-white">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-16 lg:py-20">
        <p className="text-xs uppercase tracking-[0.24em] font-semibold text-blue-900 mb-3">
          {t("terms.updated")}
        </p>
        <h1 className="text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
          {t("terms.title")}
        </h1>
        <div className="mt-10 space-y-8">
          {blocks.map(([hk, bk], i) => (
            <section key={hk} data-testid={`terms-section-${i}`}>
              <h2 className="text-xl font-semibold text-slate-900">{t(`terms.${hk}`)}</h2>
              <p className="text-slate-600 leading-relaxed mt-2">{t(`terms.${bk}`)}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
